export default {
  // FrontPage.vue
  frontPageRequirementTitle: '마인',
  frontPageProvideTitle: '서플라이',
  frontPagePersonalCenterTitle: '프로필',
  login: '로그인',
  home_chatWithOctopie: '당신의 생각을 이해하고 있어요',
  home_chatNeedUnderstood: '당신의 생각을 이해했어요',
  home_draftBannerTitle: '메시지를 완성하세요',
  home_draftBannerSubtitle: 'AI가 메시지를 준비했어요 — 탭해서 이어서 진행하세요',
  home_tabHome: '홈',

  // App.vue
  appRequirementTitle: '모든 의견과 피드백을 소중히 듣고 있습니다',
  appRequirementBtn: '제출',
  appSubmitSuccess: '제출되었어요. 피드백 감사합니다',
  appFeedbackLink: '의견/피드백',
  mobile_banner_text: '최고의 경험을 위해 앱을 사용하세요',
  mobile_banner_btn: '앱 받기',

  // Common
  loading: '불러오는 중...',
  confirm: '확인',
  cancel: '취소',
  save: '저장',
  delete: '삭제',
  edit: '편집',
  add: '추가',
  search: '검색',
  refresh: '새로고침',
  change_batch: '셔플',
  back: '뒤로',
  submit: '제출',
  close: '닫기',
  ok: '확인',
  yes: '예',
  no: '아니요',
  send: '보내기',
  block: '차단',
  more: '더보기',
  logout: '로그아웃',
  settings: '설정',
  view_guide: '가이드 보기',
  feedback: '피드백',
  feedback_title: '피드백',
  feedback_new: '새 피드백',
  feedback_empty: '피드백이 아직 없어요',
  feedback_hint: '생각을 들려주세요...',
  feedback_submit: '제출',
  feedback_submit_success: '피드백을 제출했어요',
  feedback_submit_failed: '피드백 제출에 실패했어요',
  feedback_reply_label: '운영팀 답변',
  register: '회원가입',
  name: '이름',
  email: '이메일',
  mobile: '휴대폰 번호',
  password: '비밀번호',
  verification_code: '인증 코드',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: '저작권 소유',
  footerVersion: '버전 {version}',
  copy: '복사',
  regenerate: '다시 생성',
  generate: '생성',
  contact_now: '채팅',
  yours: '나',
  xiaoyao_analysis: 'AI 분석',
  brand_name: 'OctoSay',
  anonymous: '익명',
  no_summary: '요약 없음',
  file: '파일',
  discover: '발견',
  discover_title: '발견',
  discover_hotChannels: '인기 채널',
  discover_allChannels: '전체',
  discover_searchChannel: '채널 검색',
  discover_noChannels: '채널이 없어요',

  // Messages
  operationSuccess: '작업이 완료되었어요',
  operationFailed: '작업에 실패했어요',
  networkError: '네트워크 오류예요. 잠시 후 다시 시도해 주세요',
  dataLoadingFailed: '데이터를 불러오지 못했어요',
  noData: '데이터가 없어요',
  deleteConfirm: '삭제할까요?',
  saveConfirm: '저장할까요?',

  // Form Validation
  required: '필수 입력 항목이에요',
  emailInvalid: '유효한 이메일 주소를 입력하세요',
  phoneInvalid: '유효한 전화번호를 입력하세요',
  passwordTooShort: '비밀번호는 {min}자 이상이어야 해요',
  passwordMismatch: '입력한 비밀번호가 일치하지 않아요',

  // Time
  today: '오늘',
  yesterday: '어제',
  justNow: '방금 전',
  minutesAgo: '{min}분 전',
  hoursAgo: '{hour}시간 전',
  daysAgo: '{day}일 전',

  // Footer
  about: '소개',
  footerPrivacy: '개인정보 처리방침',
  footerTerms: '이용약관',
  footerSupport: '도움말 및 지원',

  // Register
  registerAgeConfirm: '저는 13세 이상입니다',
  registerAgeConfirm18: '저는 18세 이상임을 확인합니다',
  registerTermsPrefix: '아래 내용을 읽고 동의합니다',
  registerTermsAnd: '및',
  registerAgeError: '연령을 확인해 주세요',
  registerTermsError: '이용약관과 개인정보 처리방침에 동의해 주세요',

  // Chat
  chatPrivacyTip: '허브에 하고 싶은 말을 입력하면 AI가 먼저 대화로 세부 사항을 확인해요. 확인하면 메시지와 AI 요약이 함께 게시되고, AI가 계속 매칭해 줘요.',
  aiChat_quickSuggestions: '이렇게 말해보세요',
  aiChat_welcome: "안녕! 어떤 걸 찾고 있는지 말해 주세요.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: '세부 사항을 이해했어요. 게시하면 매치를 찾아드려요',
  aiChat_readyToPostHint: '게시 후에도 세부 사항을 추가하고 싶으면 언제든 AI와 대화를 이어가세요',
  aiChat_progressStep1: '세부 사항 이해',
  aiChat_progressStep1Done: '세부 사항을 이해했어요',
  aiChat_progressStep2: 'AI 요약',
  aiChat_progressStep2Desc: 'AI가 매칭용 요약을 만들어요',
  aiChat_progressStep3: '허브에 게시',
  aiChat_progressStep3Desc: '게시하면 매치를 찾아요',
  aiChat_publishExtraHint: '허브 멤버들에게 하고 싶은 말을 입력하세요',
  aiChat_publishMsgRequired: '필수',
  aiChat_publishMsgLabel: '허브 멤버들에게 하고 싶은 말',
  aiChat_matchSummaryLabel: 'AI 요약',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: '아래 콘텐츠는 AI가 생성한 것으로 참고용입니다',
  aiChat_publishSuggestionHint: '눌러서 바꾸기',
  aiChat_allowDirectContact: '직접 연락 허용',
  aiChat_allowDirectContactDesc: '매치 없이도 다른 사람이 당신에게 직접 연락할 수 있어요',
  channel_chat_session_publishToChannel: 'Octo 그룹에 게시',
  aiChat_newChat: '초기화',

  // Channels / 그룹
  home_tabChannels: 'Octo 그룹',
  channels_title: 'Octo 그룹',
  channels_myChannels: '참여 중인 허브',
  channels_discover: '발견',
  channels_noChannels: '허브가 아직 없어요',
  channels_noMyGroupsTitle: '아직 참여한 허브가 없어요',
  channels_noMyGroupsSubtitle: '허브를 검색해서 참여하고, 새로운 인연을 시작해 보세요',
  channels_searchGroupsBtn: '허브 검색',
  channels_loginPrompt: '로그인하고 허브를 확인하세요',
  channels_create: 'Octo 그룹 만들기',
  channels_search: 'Octo 그룹 검색',
  channels_searchMyGroups: '나의 Octo 그룹 검색',
  channels_searchHint: '검색',
  channels_searchHintChats: '채팅 검색...',
  channels_searchHintGroups: '허브 검색...',
  channels_searchHintMy: '참여 중인 허브 검색...',
  channels_joinByCode: '코드로 참여',
  channels_joinByCodeTitle: '코드로 Octo 그룹 참여',
  channels_joinByCodeHint: 'Octo 그룹 코드 입력',
  channels_joinByCodeConfirm: '참여',
  channels_joinByCodeNotFound: '허브를 찾을 수 없어요',
  channels_createNewGroup: '새 Octo 그룹 만들기',
  channels_noResults: '허브를 찾을 수 없어요',
  channel_detail_join: '참여',
  channel_detail_leave: '나가기',
  channel_detail_members: '멤버',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name}님이 참여했습니다',
  channelJoinMsg_twoJoined: '{name1}님과 {name2}님이 참여했습니다',
  channelJoinMsg_multiJoined: '{name1}님, {name2}님 외 {n}명이 참여했습니다',
  channelJoinMsg_oneAndMoreJoined: '{name}님 외 {n}명이 참여했습니다',
  channelJoinMsg_membersJoined: '{n}명이 참여했습니다',

  // Feed
  channels_feed: '채팅',
  channels_groups: '허브',
  feed_related: '관련',
  feed_recommend: '추천',
  feed_empty: '피드가 아직 없어요. 인기 허브를 둘러보세요',
  feed_goToGroup: '허브에서 보기',
  feed_joinGroupAndSendMsg: '허브에 참여하고 메시지를 보내보세요',
  channel_detail_channelCode: 'Octo 그룹 코드',
  channel_detail_invitePhrase: '"{name}" 그룹에 초대합니다\n초대 코드 {code} · 앱을 열면 자동 참여 · AI가 먼저 정리하고 맞는 상대를 찾아드립니다',
  channel_detail_post: '허브에 게시',
  channel_detail_aiHint: "허브에 메시지를 쓰면 AI가 먼저 세부 사항을 확인해요",
  channel_input_hint: '무언가 적어보세요…',
  channel_leave_confirm_message: '이 허브를 나갈까요? 나가면 허브 메시지를 더 이상 받지 않아요.',
  channel_invite_notFound: '허브가 없거나 링크가 만료되었어요',
  channel_invite_joinBtn: 'OctoSay 앱 다운로드',
  channel_invite_hint: '앱을 다운로드한 후 이 QR코드를 스캔하거나 허브 이름을 검색해서 참여하세요',
  channel_invite_globalHintTitle: '글로벌 버전을 다운로드하려고 해요',
  channel_invite_globalHintIOS: '이 앱은 중국 App Store에서는 다운로드할 수 없을 수 있어요. 중국 외 지역 Apple Store로 전환해 "OctoSay"를 검색하거나, 아래에서 APK를 직접 다운로드하세요.',
  channel_invite_globalHintAndroid: '지역에 따라 Google Play에 접근하지 못할 수 있어요. APK를 직접 다운로드하거나 Google Play를 이용해 보세요.',
  channel_invite_globalHintDefault: '지역 앱 스토어에서는 다운로드할 수 없을 수 있어요. APK를 직접 다운로드하거나 App Store를 이용해 보세요.',
  channel_invite_globalBtnAppStore: 'App Store로 가기',
  channel_invite_globalBtnGooglePlay: 'Google Play로 가기',
  channel_invite_globalBtnAPK: 'APK 직접 다운로드',
  channel_invite_defaultDesc: 'OctoSay의 {name} 참여하기',
  share: '공유',
  share_channel: '허브 공유',
  share_channel_link: '링크 공유',
  channel_detail_inviteCode: '초대 코드',
  channel_detail_copyLink: '링크 복사',
  share_session_title: 'OctoSay의 게시물',
  share_match_title: 'OctoSay의 매치',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: '{userName}님이 OctoSay에 올린 글을 확인해 보세요',
  session_share_notFound: '게시물이 없거나 링크가 만료되었어요',
  session_share_fromChannel: 'Octo 그룹에서',
  session_share_downloadBtn: 'OctoSay 앱 다운로드',
  session_share_hint: '앱을 다운로드하면 게시물 전체를 보고 허브에 참여할 수 있어요',
  session_share_openInApp: '앱에서 열기',
  toast_link_copied: '링크를 복사했어요',
  toast_no_share_data: '공유할 내용이 없어요',
  channels_joinByQR: 'QR코드',
  channels_joinByQRWebHint: '웹에서는 QR 스캔을 지원하지 않아요. 허브 코드를 입력해 참여해 주세요.',
  channels_joinByQRTitle: 'QR코드로 참여',
  channel_detail_qrCode: 'QR코드',
  channel_detail_qrCodeSave: '이미지 저장',
  channel_detail_qrCodeSaveHint: '이미지를 우클릭해 저장하세요',
  channel_detail_qrCodeSaved: '갤러리에 저장했어요',
  channel_detail_qrCodeSaveFailed: '저장에 실패했어요. 다시 시도해 주세요',
  channel_detail_locateFailed: '메시지를 찾지 못했어요',
  channel_detail_locateError: '메시지 찾기 중 오류가 발생했어요',
  channel_detail_myMessages: '나의 메시지',
  channel_detail_searchMessages: '메시지 검색',
  channel_detail_aiChat: 'AI 채팅',
  channel_detail_matchHistory: '매치 기록',
  channel_create_title: 'Octo 그룹 만들기',
  channel_create_name: 'Octo 그룹 이름',
  channel_create_description: '설명',
  channel_create_submit: '만들기',
  channelCreate_aiAssist: 'AI가 당신에게 맞는 허브 만들기를 도와줄게요',
  channelCreate_nameHint: '허브 이름을 입력하세요',
  channelCreate_descHint: '허브가 어떤 활동을 하는지 설명해 주세요',
  channelCreate_creating: '생성 중...',
  channelCreate_created: '허브를 만들었어요!',
  channelCreate_failed: '허브 생성에 실패했어요',
  channelCreate_welcomeMsg: "안녕하세요! 허브 만들기를 도와드릴게요. 어떤 허브를 만들고 싶은지—주제나 목적 등—말씀해 주시면 허브 이름과 소개로 정리하고, 프로필 사진도 자동으로 만들어 드릴게요.",
  channelCreate_aiHint: '허브 주제를 적어보세요...',
  channelCreate_clarifyingProgress: '허브 주제를 정리하는 중...',
  channelCreate_readyToCreate: 'Octo 그룹를 만들 수 있어요',
  channelCreate_step1: '주제 설명',
  channelCreate_step1Done: '아이디어가 명확해졌어요',
  channelCreate_step2: 'Octo 그룹 만들기',
  channelCreate_confirmBtn: '생성 확인',
  channelCreate_publicNotice: '허브는 공통의 관심사를 가진 사람들이 모이는 공개 공간이에요. 플랫폼은 필요에 따라 허브를 관리·조정·통합할 수 있어요. 관심 있을 만한 사람에게 허브를 공유해 보세요.',
  channelCreate_similarGroupsTitle: '비슷한 Octo 그룹 발견',
  channelCreate_similarGroupsDesc: '이 허브들이 당신에게 맞을 수 있어요',
  channelCreate_exactMatchHint: '같은 이름의 허브가 이미 있어요!',
  channelCreate_joinHint: '이 기존 허브들이 당신에게 맞을 수 있어요',
  channelCreate_joinExisting: '기존 Octo 그룹 참여하기',
  channelCreate_stillCreate: '그래도 새로 만들기',
  channel_chat_session_comments: '댓글',
  channel_chat_session_commentHint: '댓글 쓰기...',
  channel_chat_session_sendComment: '댓글',
  channel_chat_session_loadMore: '더 보기',
  channel_chat_session_noComments: '댓글이 아직 없어요',
  channel_chat_session_deleteComment: '삭제',
  channelSearch_title: '허브 내 검색',
  channelSearch_placeholder: '메시지 검색...',
  channelSearch_onlyMine: '내 글만',
  channelSearch_tabAllMessages: '허브 메시지',
  channelSearch_tabMyMessages: '나의 메시지',
  chatMsgSearch_placeholder: '메시지 검색',
  chatMsgSearch_tabMsgs: '메시지',
  chatMsgSearch_tabContacts: '연락처',
  chatMsgSearch_emptyPrompt: '키워드를 입력해 메시지를 검색하세요',
  chatMsgSearch_tooShort: '2자 이상 입력해 검색해 주세요',
  chatMsgSearch_contactEmptyPrompt: '사용자 이름 또는 이메일로 연락처를 검색하세요',
  chatMsgSearch_noContacts: '일치하는 연락처가 없어요',
  chatMsgSearch_inChatPlaceholder: '현재 채팅에서 검색',
  channelHistory_title: '기록',
  channelHistory_myMessages: '나의 메시지',
  channelHistory_loadMore: '더 보기',
  channel_settings_push: 'Octo 그룹 알림',
  channel_settings_commentPush: '댓글 알림',
  channel_settings_likePush: '좋아요 알림',
  channel_settings_receiveNotifications: '알림 받기',
  channel_settings_directContact: '직접 연락 허용',
  session_published: '게시됨',
  session_publishFailed: '게시에 실패했어요',
  session_setDirectContactSuccess: '설정을 저장했어요',
  session_setDirectContactFailed: '설정 저장에 실패했어요',
  session_setPrivate: '비공개로 설정',
  session_setPublic: '공개로 설정',
  session_pauseMatching: '매칭 일시 중지',
  session_resumeMatching: '매칭 재개',
  session_matchPausedToast: '매칭이 일시 중지되었습니다',
  session_matchResumedToast: '매칭이 재개되었습니다',
  match_matchingPausedTitle: '매칭이 일시 중지되었습니다',
  match_reasonTag: '매칭 이유',
  match_matchingPausedHint: '언제든 매칭을 다시 켤 수 있어요.',
  session_confirmSetPrivate: '이 콘텐츠를 비공개로 설정할까요? 다른 사용자는 볼 수 없게 돼요.',
  session_messageIsPrivate: '이 메시지는 비공개 메시지예요',
  chatSessionComment_replyHint: '댓글 쓰기...',
  chatSessionComment_reply: '댓글',
  chatSessionComment_count: '댓글 {n}개',
  chatSessionMatch_count: '매치 {n}건',
  chatSessionComment_replyTo: '답글',
  chatSessionComment_inputHint: '댓글 쓰기...',
  chatSessionComment_send: '보내기',
  chatSessionComment_delete: '삭제',
  chatSessionComment_deleteConfirm: '이 댓글을 삭제할까요?',
  chatSessionComment_loadMore: '더 보기',
  chatSessionComment_noMore: '더 이상 댓글이 없어요',
  chatSessionComment_loginToComment: '댓글을 달려면 로그인하세요',
  chatSessionComment_viewEarlier: '이전 답글 {n}개 보기',
  chatSessionLike_like: '좋아요',
  chatSessionLike_liked: '좋아요 완료',
  chatSessionLike_count: '좋아요',
  chatSessionBookmark_bookmark: '북마크',
  chatSessionBookmark_bookmarked: '북마크 완료',
  chatSessionMatch_viewMatches: '매치 보기',
  chatSessionMatch_matchHistory: '매치 기록',
  chatSessionMatch_noMatches: '매치가 아직 없어요',
  channel_match_achievement: '{count}개의 글이 매치에 성공했어요',
  channel_match_achievement_view: '보기 →',
  channel_matchHistory_title: '채널 매치 기록',
  chatSessionMatch_matchedAt: '{time}에 매치',
  discover_userMsgLabel: '이 사람의 글',
  common_loading: '불러오는 중...',
  common_sending: '전송 중...',
  common_error: '오류',
  common_success: '성공',
  common_me: '나',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI가 필요를 명확히 다듬어 보내는 메시지가 확실히 효과를 내도록 해줘요. 게시 후에도 계속 매칭해 줘요",
  aiChat_clarifyingAlmostDone: '거의 다 됐어요. 확인해 주세요',
  aiChat_clarifyingOneMore: '질문 1개만 더 답하면 바로 게시할 수 있어요',
  aiChat_clarifyingRemaining: '약 {count}라운드 더 진행하면 금방 끝나요',
  aiChat_clarifyingEvaluating: '진행 상황을 평가하는 중...',
  aiChat_setPublicMatch: '공개하고 매칭',
  aiChat_needsClarifiedPublic: "이제 이해했어요. 확인하고 게시하면 AI가 계속 매치를 찾아드릴게요.\n세부 사항은 언제든 더 알려주셔도 돼요.",
  aiChat_needsClarifiedPrivate: '대체로 파악했어요! 공개로 설정하면 AI가 계속 매치를 찾아드릴게요!\n세부 사항은 언제든 알려주세요.',
  aiChat_setPublicTitle: '공개로 설정',
  aiChat_setPublicMessage: '콘텐츠가 다른 사람에게 표시되어 OctoSay가 매치를 찾을 수 있어요.\n\n공유될 정보:\n• 사용자 이름과 프로필 사진\n• 콘텐츠 요약\n• 대화 내용 (발견 탭에 표시)\n\n언제든 비공개로 되돌릴 수 있어요.',
  aiChat_findMatches: '매치 결과 보기',
  aiChat_publishing: '게시 중...',
  aiChat_matchSectionTitle: '메시지는 이 그룹에 가장 잘 맞아요 — 눌러 바로 게시',
  aiChat_joinedBadge: '가입됨',
  aiChat_matchSectionEmpty: '잘 맞는 그룹이 아직 없어요. 새 그룹을 만들어 게시할 수 있어요',
  aiChat_suggestPublishCreateNew: '새 그룹 만들기',
  aiChat_repickChannel: '그룹 변경',
  aiChat_creatingChannelTitle: '맞는 그룹이 없어 새 그룹을 만들고 있어요',
  aiChat_creatingChannelHint: '요청에 맞춰 그룹을 만들고 있어요. 완료 후 바로 게시로 이동해요. 보통 10~30초 걸려요',
  aiChat_publishToChannelHint: '"{name}"에 게시됩니다',
  aiChat_pickChannelTitle: '게시할 그룹 선택',
  aiChat_matchingChannelTitle: '적합한 그룹을 찾고 있어요',
  aiChat_matchingChannelHint: 'AI가 요청 내용을 기준으로 검색하고 있어요. 보통 수 초에서 30초 정도 걸려요',
  aiChat_matchUnavailableTitle: '추천을 불러올 수 없어요',
  aiChat_matchUnavailableHint: '아래에서 그룹을 검색하거나, 닫았다가 다시 열어 보세요',
  aiChat_waitSlowHint: '평소보다 오래 걸리지만 처리 중이에요. 조금만 더 기다려 주세요. 아래에서 그룹을 검색할 수도 있어요',
  aiChat_creatingSlowHint: '평소보다 오래 걸리지만 그룹을 만들고 있어요. 조금만 더 기다려 주세요. 완료 후 바로 게시로 이동해요',
  aiChat_pickChannelEmptyHint: '관련 그룹을 찾지 못했어요. 새 그룹을 만들어 게시해 보세요',
  aiChat_loadMore: '더 보기',
  sidebar_publish: '게시하기',
  chat_selectLocationOnMap: '지도에서 위치를 선택해 주세요',

  // App.vue new
  placeholder_email: '이메일을 입력하세요',
  placeholder_mobile: '휴대폰 번호를 입력하세요',
  placeholder_password: '비밀번호를 입력하세요',
  placeholder_name: '이름을 입력하세요',
  random_nickname: '랜덤',
  placeholder_verification_code: '인증 코드를 입력하세요',
  sending: '전송 중...',
  registering: '가입 중...',
  send_code: '코드 전송',
  retry_in_seconds: '{countdown}초 후 재시도',
  toast_enter_email: '이메일을 입력하세요',
  toast_enter_mobile: '휴대폰 번호를 입력하세요',
  toast_invalid_email: '유효한 이메일 형식을 입력하세요',
  toast_invalid_mobile: '유효한 휴대폰 번호를 입력하세요',
  toast_send_code_failed: '인증 코드 전송에 실패했어요',
  toast_code_sent: '이메일로 인증 코드를 보냈어요',
  toast_code_sent_sms: '휴대폰으로 인증 코드를 보냈어요',
  toast_send_code_error: '인증 코드 전송에 실패했어요. 잠시 후 다시 시도해 주세요',
  toast_fill_all_fields: '모든 항목을 입력해 주세요',
  toast_login_failed: '로그인에 실패했어요',
  toast_login_success: '로그인했어요',
  oauthOr: '또는',
  toast_oauth_login_failed: 'Google 로그인에 실패했어요',
  toast_oauth_login_error: 'Google 로그인 중 오류가 발생했어요. 다시 시도해 주세요',
  toast_login_error: '로그인에 실패했어요. 잠시 후 다시 시도해 주세요',
  toast_register_failed: '회원가입에 실패했어요',
  toast_register_success: '가입했어요',
  toast_register_error: '회원가입에 실패했어요. 잠시 후 다시 시도해 주세요',

  // AdBanner.vue
  ad: '광고',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: '연결하기 전에',
  contactAd_gateSubtitle: '이 짧은 대기 덕분에 OctoSay를 무료로 유지할 수 있어요 — 지원해 주셔서 감사합니다!',
  contactAd_waitBtn: '{sec}초 후 계속할 수 있어요',
  contactAd_continueBtn: '채팅 계속하기',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: '채팅',

  // AiMatch.vue
  ai_welcome_msg: '안녕하세요, AI예요. 동행 찾기, 파트너 찾기, 스킬 교환 등 뭐든지 말해주세요.',
  default_username: '사용자',

  // AvatarCropDialog.vue
  crop_hint: '핀치로 확대/축소, 드래그로 조정',
  toast_crop_failed: '이미지 자르기에 실패했어요',

  // ChatBox.vue
  loading_match_info: '매치 정보를 불러오는 중...',
  view_match_details: '매치 상세 보기',
  step_clarify_needs: '확인',
  step_ai_matching: '허브에 게시',
  step_connect: 'AI 매칭',
  make_private: '비공개로 설정',
  setting: '설정 중...',
  action_photo: '사진',
  action_file: '파일',
  action_video: '동영상',
  action_location: '위치',
  hint_get_app: '앱을 받아 연락을 놓치지 마세요',
  match_finding_title: '나의 매치',
  match_finding_subtitle: 'AI가 계속 매치를 찾고 있어요',
  match_time_hint: '보통 1~2분 정도 걸려요',
  match_result_stats: '베스트 매치 {matched}건을 찾았어요{interested}',
  match_tap_to_connect: '눌러서 대화를 시작하세요',
  match_channel_hint: '허브 <strong>#{channel}</strong>에서 매칭 중이에요. 같은 허브를 우선하지만, 필요하면 다른 허브도 포함될 수 있어요.',
  label_perfect_match: '베스트 매치',
  label_worth_a_look: '확인할 가치',
  match_no_result_title: '딱 맞는 상대를 찾는 중',
  match_no_result_desc: '세부 사항을 더 공유하면 OctoSay가 매치를 찾기 쉬워져요. 매치 알림을 받으려면 앱을 설치해 주세요.',
  go_back: '뒤로',
  no_public_requirements: '공개 글이 아직 없어요',
  channelEmpty_title: '아직 조용하네요',
  channelEmpty_subtitle: '첫 번째로 생각을 공유해 보세요',
  channelEmpty_hint: "생각을 쓰면 AI가 내용을 정리하고 계속 매칭해 메시지가 묻히지 않아요",
  channelEmpty_action: '생각을 공유해 보세요',
  stay_connected: '연락 유지하기',
  download_app_desc: '앱을 받으면 채팅하고, 누군가 연락하면 바로 알림을 받을 수 있어요!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK 직접 다운로드',
  match_history: '매치 기록',
  no_match_history: '매치 기록이 아직 없어요',
  finding_matches: 'AI가 계속 매치를 찾고 있어요 - 허브에 메시지를 게시하면 시작돼요',
  discover_connect_hint: '매치되면 바로 채팅할 수 있어요!',
  match_initializing: '초기화 중...',
  placeholder_login_to_chat: '로그인하고 하고 싶은 말을 알려주세요',
  toast_need_clear: '생각이 명확해졌어요!',
  toast_ai_responding: 'AI가 답변 중이에요. 잠시만 기다려 주세요...',
  toast_uploading_image: '이미지를 업로드하는 중이에요. 잠시만 기다려 주세요...',
  toast_uploading_file: '파일을 업로드하는 중이에요. 잠시만 기다려 주세요...',
  toast_max_photos: '사진은 최대 {max}장까지 가능해요',
  toast_uploading: '업로드 중이에요. 잠시만 기다려 주세요...',
  toast_file_too_large: '{name}이(가) 5MB 제한을 초과해요',
  toast_video_too_large: '{name}이(가) 20MB 제한을 초과해요',
  toast_video_processing: '동영상을 처리 중이에요. 잠시만 기다려 주세요…',
  toast_upload_link_failed: '업로드 링크를 가져오지 못했어요',
  analyzing_image: '이미지를 분석하는 중...',
  toast_location_confirmed: '위치를 확인했어요',
  toast_location_selected: '위치를 선택했어요',
  toast_enter_search: '검색 내용을 입력하세요',
  toast_search_failed: '검색에 실패했어요',
  toast_no_locations: '위치를 찾지 못했어요',
  toast_search_error: '검색에 실패했어요. 다시 시도해 주세요',
  toast_located_at: '위치: {address}',
  toast_shared_finding: '공유했어요! 매치를 찾는 중...',
  toast_update_failed: '업데이트에 실패했어요',
  toast_set_private: '비공개로 설정했어요',
  toast_no_matches: '매치를 찾지 못했어요',
  toast_matches_found: '베스트 매치 {count}건을 찾았어요',
  toast_start_conversation_first: '먼저 대화를 시작해 주세요',
  toast_load_history_failed: '매치 기록을 불러오지 못했어요',
  toast_ai_timeout: 'AI 응답이 지연돼요. 다시 시도해 주세요',
  toast_message_blocked: '메시지가 차단되었어요',
  network_disconnected: '네트워크가 끊겼어요',
  toast_publish_success: '허브에 게시했어요!',
  toast_publish_failed: '허브 게시에 실패했어요',

  // ChatMsgList.vue
  collapse_thinking: '생각 과정 접기',
  expand_thinking: '생각 과정 펼치기',
  thinking: '생각 중',
  select_date: '날짜 선택',
  selected_location: '선택한 위치',
  msg_blocked: '차단됨',
  retry: '다시 시도',
  msg_read: '읽음',
  msg_sent: '전송됨',
  msg_unread: '안 읽음',
  label_start_datetime: '시작 날짜 및 시간:',
  label_end_datetime: '종료 날짜 및 시간:',
  toast_select_start_datetime: '시작 날짜와 시간을 선택해 주세요',
  toast_end_before_start: '종료 시간은 시작 시간보다 이를 수 없어요',
  report_message: '메시지 신고',
  block_user: '사용자 차단',
  msg_revoke: '보내기 취소',
  msg_quote: '인용',
  msg_revoked_self: '메시지를 보내기 취소했어요',
  msg_revoked_other: '상대가 메시지를 보내기 취소했어요',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: '메시지가 취소되었어요',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: '이 메시지는 규정 위반으로 플랫폼에 의해 삭제되었습니다',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: '보내기 취소했어요',
  toast_revoke_failed: '보내기 취소에 실패했어요',
  toast_load_data_failed: '데이터를 불러오지 못했어요. 새로고침 후 다시 시도해 주세요',
  toast_file_url_missing: '파일 URL이 없어요',
  toast_block_success: '사용자를 차단했어요',
  toast_block_failed: '사용자 차단에 실패했어요',

  // ChatSession.vue
  no_more_records: '더 이상 기록이 없어요.',
  title_needs_clarified: '생각이 명확해졌어요',
  title_clarifying: '생각을 정리하고 있어요',
  title_public: '공개',
  title_private: '비공개',
  badge_clarified: '명확화 완료',
  badge_clarifying: '명확화 중',
  badge_only_me: '나만 보기',
  badge_expired: '만료됨',
  title_expired: '만료됨',
  no_chat_history: '채팅 기록이 없어요',

  // ContactMethods.vue
  block_status_banner: '이 사용자를 차단했어요',
  unblock_user: '차단 해제',
  toast_block_missing_id: '차단할 수 없어요: 사용자 ID가 없어요',
  dialog_block_confirm: '{name}님을 차단할까요? 상대의 메시지는 더 이상 받지 않게 돼요.',
  toast_user_blocked: '{name}님을 차단했어요',
  toast_unblock_missing_id: '차단 해제할 수 없어요: 사용자 ID가 없어요',
  toast_user_unblocked: '{name}님의 차단을 해제했어요',

  // BlockedUsers.vue
  blocked_users: '차단한 사용자',
  blocked_users_empty: '차단한 사용자가 없어요',
  blocked_users_empty_hint: '차단한 사용자는 더 이상 메시지를 보낼 수 없어요',
  blocked_users_unblock: '차단 해제',
  dialog_unblock_confirm: '해제하면 상대가 다시 메시지를 보낼 수 있어요.',
  toast_unblock_success: '차단을 해제했어요',
  toast_unblock_failed: '차단 해제에 실패했어요. 다시 시도해 주세요',
  blocked_users_load_failed: '불러오기에 실패했어요. 눌러서 다시 시도',
  blocked_users_blocked_at: '{date}에 차단',
  blocked_users_unknown_user: '알 수 없는 사용자',

  // Contacts.vue
  no_connections: '아직 메시지가 없어요',
  chat_with: '{name}님과 채팅',
  toast_load_contacts_failed: '연락처를 불러오지 못했어요: {msg}',
  toast_load_contacts_error: '연락처를 불러오지 못했어요. 새로고침 후 다시 시도해 주세요.',
  time_just_now: '방금 전',
  time_minutes_ago: '{min}분 전',
  time_hours_ago: '{hour}시간 전',
  time_days_ago: '{day}일 전',

  // InteractionNotification.vue
  interaction_notification_title: '알림',
  interaction_notification_subtitle: '댓글 & 좋아요',
  interaction_notification_empty: '알림이 아직 없어요',
  interaction_notification_comment: '댓글: {content}',
  interaction_notification_like: '내 글에 좋아요를 눌렀어요',
  interaction_notification_reply: '답글: {content}',
  interaction_notification_bookmark: '내 글을 북마크했어요',
  toast_load_notifications_failed: '알림을 불러오지 못했어요: {msg}',
  toast_load_notifications_error: '알림을 불러오지 못했어요. 새로고침 후 다시 시도해 주세요.',
  mark_all_read: '모두 읽음으로 표시',
  toast_mark_all_read_failed: '작업에 실패했어요. 다시 시도해 주세요',
  contacts_dnd: '알림 음소거',
  dnd_enabled: '알림을 음소거했어요',
  dnd_disabled: '알림 음소거를 해제했어요',
  dnd_action_enable: '알림 음소거',
  dnd_action_disable: '알림 음소거 해제',

  // Discover.vue
  toast_load_sessions_failed: '세션을 불러오지 못했어요: {msg}',
  toast_load_sessions_error: '세션을 불러오지 못했어요',
  discover_noMessages: '메시지가 아직 없어요',

  // EmojiInputArea.vue
  placeholder_default: 'AI에게 더 자세히 알려주세요',
  userChat_typeMessage: '메시지 입력...',
  select_emoji: '이모티콘 선택',
  badge_new: 'NEW',
  channel_search_placeholder: '채널 입력',
  channel_picker_empty: '채널 입력',

  // FrontPage.vue
  tab_chat_with_ai: 'OctoSay에게 이해받기',
  history_chats: '기록',
  tab_connections: '매치',
  tab_conversations: '메시지',
  tab_profile: '프로필',
  new_session: '새로 만들기',
  history_tab_chats: '내 글',
  history_tab_matches: '매치',
  channels_octosay: 'Octo 그룹',
  tab_matches: '매치',
  tab_messages: '메시지',

  // Header.vue
  slogan: 'OctoSay - 당신을 이해하고, 딱 맞는 상대를 이어주는 AI',
  app_name: 'OctoSay',
  slogan_short: '당신을 이해하고, 딱 맞는 상대를 이어주는 AI',
  slogan_ai: '당신을 이해하고, 딱 맞는 상대를 이어주는 AI',
  get_the_app: '앱 받기',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: '또는 앱 스토어에서 "OctoSay" 검색',

  // MapLocationPicker.vue
  placeholder_search_location: '위치 검색...',
  coords_display: '경도: {lng}, 위도: {lat}',
  toast_no_geolocation: '브라우저가 위치 정보를 지원하지 않아요',
  toast_location_permission_denied: '위치를 가져올 수 없어요. 위치 권한을 확인해 주세요',
  loading_address: '주소를 불러오는 중...',

  // MatchedSession.vue
  created_at: '생성: {time}',
  ai_match_analysis: 'AI 매치 분석',
  error_missing_session_params: '필요한 세션 파라미터가 없어요',
  match_private_hint: '이 세션은 비공개라 내용을 볼 수 없어요',

  // PersonalCenter.vue
  label_name: '이름:',
  placeholder_enter_name: '이름을 입력하세요',
  label_bio: '소개:',
  placeholder_enter_bio: '자신에 대해 적어보세요',
  placeholder_bio_empty: '자신을 한마디로 소개해 보세요',
  bio: '소개',
  delete_account: '계정 삭제',
  delete_warning: '이 작업은 되돌릴 수 없어요.',
  delete_data_intro: '다음 데이터가 영구 삭제됩니다:',
  delete_item_profile: '프로필 정보',
  delete_item_chat: '채팅 기록 및 세션',
  delete_item_contact: '연락처 정보',
  delete_item_all: '모든 관련 데이터',
  final_confirmation: '최종 확인',
  delete_confirm_prompt: '확인하려면 "delete"를 입력하세요:',
  placeholder_type_delete: 'delete 입력',
  private_token: '프라이빗 토큰',
  token_desc: 'API 접근용 토큰을 생성합니다',
  toast_not_logged_in: '로그인되지 않은 사용자',
  toast_name_required: '이름은 필수예요',
  toast_save_success: '저장했어요',
  toast_save_failed: '저장에 실패했어요',
  toast_image_too_large: '이미지가 5MB 제한을 초과해요',
  toast_avatar_updated: '프로필 사진이 변경되었어요',
  toast_avatar_failed: '프로필 사진 변경에 실패했어요',
  toast_upload_failed: '업로드에 실패했어요',
  toast_token_generated: '토큰을 생성했어요',
  toast_token_failed: '토큰 생성에 실패했어요',
  toast_copied: '클립보드에 복사했어요',
  toast_copy_failed: '복사에 실패했어요',
  toast_account_deleted: '계정이 삭제되었어요',
  toast_delete_account_failed: '계정 삭제에 실패했어요',
  toast_logout_success: '로그아웃했어요',
  toast_logout_failed: '로그아웃에 실패했어요',
  profile_tab_messages: '메시지',
  profile_tab_comments: '댓글',
  profile_tab_likes: '좋아요',
  profile_tab_bookmarks: '북마크',
  profile_empty_messages: '아직 글을 올린 적이 없어요',
  profile_empty_comments: '아직 댓글을 남긴 적이 없어요',
  profile_empty_likes: '아직 좋아요를 누른 적이 없어요',
  profile_empty_bookmarks: '아직 북마크한 글이 없어요',
  profile_reply_to: '{name}에게 답글',
  profile_stats_posts: '메시지',
  profile_stats_comments: '댓글',
  profile_stats_likes: '받은 좋아요',
  profile_joined: '{date} 가입',

  // ReportDialog.vue
  report_message_title: '메시지 신고',
  report_reason_prompt: '이 메시지를 신고하는 이유를 선택해 주세요:',
  report_spam: '스팸',
  report_harassment: '괴롭힘 또는 따돌림',
  report_inappropriate: '부적절한 콘텐츠',
  report_other: '기타',
  placeholder_report_desc: '문제를 설명해 주세요 (선택)',
  toast_select_reason: '이유를 선택해 주세요',
  toast_report_success: '신고가 접수되었어요',
  toast_report_failed: '신고 접수에 실패했어요',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[사진]',
  summary_images: '[사진x{count}]',
  summary_file: '[파일]',
  summary_files: '[파일x{count}]',
  summary_video: '[동영상]',
  summary_videos: '[동영상x{count}]',
  summary_location: '[위치]',
  summary_locations: '[위치x{count}]',
  summary_emoji: '[이모티콘]',
  summary_emojis: '[이모티콘x{count}]',
  summary_voice: '[음성]',
  summary_voices: '[음성x{count}]',
  summary_mixed: '[복합 콘텐츠]',
  summary_other: '[기타]',

  // Voice messages
  voice: '음성',
  voice_recording: '녹음 중...',
  toast_voice_too_short: '녹음이 너무 짧아요',
  toast_voice_failed: '음성 전송에 실패했어요',
  toast_mic_permission_denied: '마이크에 접근할 수 없어요. 브라우저 설정에서 권한을 켜주세요',
  toast_recording_not_supported: '이 브라우저는 음성 녹음을 지원하지 않아요',
  voice_load_failed: '음성 메시지를 불러오지 못했어요',

  // Expire At
  aiChat_expireLine: '유효 기간: {date}까지. 언제든 AI에게 알려주세요',
  aiChat_expireExpired: '콘텐츠 유효 기간이 지나 더 이상 공개되지 않아요. 언제든 AI에게 알려서 기간을 갱신하세요',

  // MatchedSession.vue
  detail: '상세',

  // Match notification hints
  match_new_result_hint: '새 매치 결과가 생기면 이메일로 알려드려요. 확실히 받으려면 앱을 설치해 주세요.',

  // Match notification hints
  match_connection_notify_hint: '매치됐고 알림을 보냈어요! 어서 인사해 보세요!',
  match_continuousMatching: 'AI가 계속 매치를 찾고 있어요',
  match_continuousMatchingHint: '새 매치가 생기면 바로 알려드릴게요',
  match_continuousMatchingOthers: 'AI가 계속 매치를 찾고 있어요',
  match_continuousMatchingOthersHint: '새 결과는 여기에 표시돼요',
  match_noResultsTitleOthers: '매치를 찾는 중',
  match_noResultsHintOthers: 'AI가 계속 매치를 찾고 있어요. 찾으면 여기에 표시돼요.',
  match_newMatchFound: '새 매치 {n}건을 발견했어요!',
  match_worth_exploring_hint: '연락할지 여부는 당신이 결정하세요.',

  // Matches filter tags
  filter_all: '전체',
  filter_best_connection: '베스트 매치',
  filter_worth_a_look: '확인할 가치',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - 당신을 이해하고, 딱 맞는 상대를 이어주는 AI',
  landing_hero_title: '허브에 쓰기만 하세요. AI가 먼저 확인하고, 당신이 확인하면 게시되어 매치됩니다',
  landing_hero_subtitle: 'Octo 그룹에서 공유하고 싶은 메시지를 입력하세요. 게시 전에 AI가 대화로 세부 사항을 확인해요. 확인하면 메시지와 AI 요약이 함께 게시되고, 매칭이 시작됩니다.',
  landing_download_on: '다운로드:',
  landing_get_it_on: '받기:',
  landing_direct_download: '직접 다운로드',
  landing_how_title: '사용법 3단계',
  landing_step1_title: '허브에 메시지 쓰기',
  landing_step1_desc: '허브에 공유하고 싶은 메시지를 입력하세요. AI가 먼저 대화로 세부 사항을 확인해서, 모든 글이 명확하고 유용하며 매치하기 좋은 상태가 됩니다. 잡담 속에 묻히지 않아요.',
  landing_step2_title: '확인 후 게시 & 매칭',
  landing_step2_desc: '확인하면 원본 메시지와 AI 요약이 함께 허브에 게시돼요. 이후 AI가 계속 최적의 상대를 찾아주기 때문에 메시지가 묻혀 아무도 못 보는 일이 없어요.',
  landing_step3_title: '연결되면 자연스럽게 대화',
  landing_step3_desc: '매치가 생기면 양쪽 모두 서로의 AI와의 대화 기록과 AI 요약을 볼 수 있어요. 공통의 맥락이 있어서 아이스브레이킹도 어색하지 않아요.',
  // Comparison Section
  landing_comparison_title: '왜 OctoSay일까요?',
  landing_comparison_subtitle: '허브형 채팅이지만, AI가 세부 사항을 확인하고 적극적으로 매칭해 줘요.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: '콘텐츠 품질',
  landing_cmp1_other: '스팸·광고·주제 이탈 메시지 범람',
  landing_cmp1_octo: 'AI가 선별한 니즈 카드만 표시',
  landing_cmp2_label: '사람 찾기',
  landing_cmp2_other: '올리고 그저 답글 기다리기',
  landing_cmp2_octo: 'AI가 적극적으로 매칭',
  landing_cmp3_label: '노이즈 수준',
  landing_cmp3_other: '수백 개 메시지 스크롤',
  landing_cmp3_octo: '노이즈 제로, 모든 글에 의미가 있어요',
  landing_cmp4_label: '시작 난이도',
  landing_cmp4_other: '서버 찾고, 채널 뒤지고, 스스로 익히기',
  landing_cmp4_octo: '허브에 입력만 하면 AI가 확인·매칭',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: '샤오홍슈',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: '그룹 채팅은 광고와 스팸 범람',
  landing_cmp1_xhs: '홍보 글투성이라 믿기 어려워요',
  landing_cmp1_facebook: '광고와 클릭베이트가 피드를 채워요',
  landing_cmp1_reddit: '스팸과 주제 이탈 글투성이',
  landing_cmp2_wechat: '연락처와 그룹 초대뿐',
  landing_cmp2_xhs: '직접 검색하고 글을 뒤져야 해요',
  landing_cmp2_facebook: '기존 친구와 그룹에 한정돼요',
  landing_cmp2_reddit: '서브레딧을 직접 뒤지고 답글을 기다려요',
  landing_cmp3_wechat: '수백 개 그룹 메시지 스크롤',
  landing_cmp3_xhs: '피드는 추천과 광고뿐',
  landing_cmp3_facebook: '추천 글과 광고가 끝없이',
  landing_cmp3_reddit: '수백 개 댓글 스크롤',
  landing_cmp5_label: '누가 찾나요',
  landing_cmp5_wechat: '한 명씩 물어보며 운에 맡기기',
  landing_cmp5_xhs: '글 올리고 댓글 기다리며 직접 거르기',
  landing_cmp5_facebook: '그룹에서 여기저기 물어봐야 해요',
  landing_cmp5_reddit: '글 올리고 답글 기다리고 다시 거르기',
  landing_cmp5_octo: 'AI가 자동으로 계속 찾아줘요',

  landing_features_title: '핵심 기능',
  landing_feature1_title: '게시 전 확인',
  landing_feature1_desc: '양식 작성은 필요 없어요. 허브에 메시지를 쓰면 AI가 게시 전에 대화로 질문하며 당신의 니즈를 진짜 이해해요.',
  landing_feature2_title: '깔끔하게, 카오스 없이',
  landing_feature2_desc: '메시지와 AI 요약이 함께 게시돼요. OctoSay가 모든 글을 관리하니 스팸도, 주제 이탈도, 노이즈도 없어요.',
  landing_feature3_title: '선제적 매칭',
  landing_feature3_desc: '확인하고 메시지와 AI 요약이 공개되면, AI가 허브를 계속 훑으며 조건에 맞는 사람을 찾고 그 이유까지 설명해 줘요.',
  landing_feature4_title: '토픽 커뮤니티, 노이즈 제로',
  landing_feature4_desc: '스포츠, 게임, 언어 교환, 룸메이트 등 토픽 허브에 참여하세요. AI가 게시 전에 메시지를 확인하니 모든 허브가 깔끔하고 유용해요.',
  landing_feature5_title: '프라이버시 보호',
  landing_feature5_desc: '전송 후 메시지를 비공개로 설정해 나만 볼 수 있게 할 수 있어요. 완전한 통제권이 있어요.',
  landing_feature6_title: '의미 있는 대화',
  landing_feature6_desc: '노이즈도, 산만한 방해도 없이. 모든 메시지에 의미가 있어요.',
  landing_usecases_title: '어떤 상황에도',
  landing_usecases_subtitle: '무엇을 원하든 토픽 허브에 참여만 하세요. 매칭은 AI가 알아서 해줘요',
  landing_usecase_game: '게임 메이트',
  landing_usecase_language: '언어 교환',
  landing_usecase_skill: '스킬 교환',
  landing_usecase_roommate: '룸메이트 찾기',
  landing_usecase_travel: '여행 메이트',
  landing_usecase_sports: '운동 메이트',
  landing_usecase_study: '스터디 메이트',
  landing_usecase_anything: '...뭐든지 공유',
  landing_cta_title: '시작할 준비 되셨나요?',
  landing_cta_desc: '토픽 허브에 참여하고 하고 싶은 말을 쓰면, AI가 세부 사항을 확인하고, 확인하면 게시되어 딱 맞는 사람과 매치됩니다. 지금 시작하세요.',
  landing_use_now: '지금 사용하기',
  landing_groups: '허브',

  // OnboardingPage.vue
  onboarding_skip: '건너뛰기',
  onboarding_next: '다음',
  onboarding_getStarted: '시작하기',
  onboarding_step1Title: "허브에서 원하는 것을 말하세요",
  onboarding_step1Desc: "찾고 있는 것이나 하고 싶은 일을 그냥 말해 보세요. AI가 대화로 세부 사항을 확인하고 분명한 메시지로 정리해 줍니다.",
  onboarding_step2Title: '확인 후 게시 & 매칭',
  onboarding_step2Desc: "메시지가 허브에 게시되면, AI가 계속 최적의 상대를 찾아주기 때문에 메시지가 묻혀 아무도 못 보는 일이 없어요.",
  onboarding_step3Title: '연결되면 자연스럽게 대화',
  onboarding_step3Desc: "양쪽 모두 서로의 AI와의 대화 기록을 볼 수 있어요. 공통의 맥락이 있어서 아이스브레이킹도 어색하지 않아요.",

  // ChannelDetail.vue
  channel_image_limit: '이미지 1장까지',

  // ChannelMembers.vue
  channel_members_empty: '멤버가 아직 없어요',
  channel_members_title: '멤버',
  channel_role_owner: '소유자',
  channel_role_admin: '관리자',
  channel_role_member: '멤버',

  // Settings.vue
  settings_language: '언어',
  settings_language_followSystem: '시스템 설정 따르기',

  // ChatBox.vue
  match_interested_suffix: ', {count}건이 확인할 가치 있어요',

  // ChatBox.vue - AI 매칭 진행 단계
  match_stage_fetch_chat: '대화 가져오기',
  match_stage_query_expansion: '쿼리 확장',
  match_stage_semantic_search: '의미 검색',
  match_stage_deep_search: '심층 분석',
  match_stage_rerank: '스마트 매칭',
  match_stage_refining: '결과 최적화',
  match_stage_fetch_details: '상세 정보 가져오기',

  // ChannelDetail.vue - 이미지 업로드
  channel_select_image: '이미지 파일을 선택해 주세요',
  channel_image_upload_failed: '이미지 업로드에 실패했습니다. 다시 시도해 주세요',
  chatInput_channelSearchHint: "그룹 검색",
}



// WEBPACK FOOTER //
// ./src/i18n/ko.js